import React, { useMemo } from "react";

import FormRenderer from "Common/Custom/FormRenderer";



const ReservationDetails = ({ formdata, values, errors, handleChange, optionConfig }) => {

  const { Details } = formdata;



  // Dynamically update fields to add minDate for end_date

  const enhancedFields = useMemo(() => {

    return Details.map(field => {

      if (field.name === "end_date" && values.start_date) {

        // Minimum 1 hour gap

        const minDate = new Date(new Date(values.start_date).getTime() + 60 * 60 * 1000);

        return {

          ...field,

          minDate: minDate

        };

      }

      if (field.name === "start_date") {

        // Set minimum date to today at midnight to allow proper date selection
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        return {

          ...field,

          minDate: today

        };

      }

      return field;

    });

  }, [Details, values.start_date, values.end_date]);



  return (

    <div className="col-12 mt-4">

      <div className="card shadow-sm border">

        <div className="card-header border-bottom">

          <h5 className="mb-0 fw-semibold">

            <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="me-2">

              <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path>

              <line x1="3" y1="6" x2="21" y2="6"></line>

              <path d="M16 10a4 4 0 0 1-8 0"></path>

            </svg>

            Hall Room Reservation Details

          </h5>

        </div>

        <div className="card-body p-4">

          <FormRenderer

            fields={enhancedFields}

            values={values}

            errors={errors}

            handleChange={handleChange}

            optionConfig={optionConfig}

          />

        </div>

      </div>

    </div>

  );

};



export default ReservationDetails;

